import { useForm } from "react-hook-form"
import { FleContinueWrapper, FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, Skip, SwitchH2ToBodyLarge } from "../Molecules"
import { Spacer } from "../../atoms/Atoms"
import React, { useEffect, useLayoutEffect, useState } from "react"
import { CompleteFormInput } from "components/views/atoms/forms/FormInput"
import { Form } from "components/views/atoms/forms/Form"
import { TopSection } from "../TopSection"
import { BodySmall } from "../../atoms/Bodies"
import L10n from "../../../../lib/carrot-l10n"
import { useHistory } from "react-router"
import { useAboutYouFlowControls } from "../context/AboutYouFlowContext"
import useAboutYou from "../hooks/useAboutYou"
import { AboutYouTopSection } from "components/carrot-plans/shared/ProgressTracker"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYourPartnerPreferredName = ({ next, previous }) => {
  const history = useHistory()
  const { wentBack, goBack } = useAboutYouFlowControls()
  const { data, updateAboutYou, hasQuestionBeenSkipped, continueLoading } = useAboutYou()

  const [partnerPreferredName, setPartnerPreferredName] = useState(data?.partnerPreferredName || "")

  useLayoutEffect(() => {
    if (!wentBack && (data?.partnerPreferredName || hasQuestionBeenSkipped("partnerPreferredName"))) {
      history.push(next)
    }
  }, [history, wentBack, next, data?.partnerPreferredName])

  useEffect(() => {
    setPartnerPreferredName(data?.partnerPreferredName)
  }, [data?.partnerPreferredName])

  const updatePartnerPreferredName = async (data) => {
    if (partnerPreferredName) {
      await updateAboutYou(data)
      history.push(next)
    } else {
      await handleSkip()
    }
  }

  const handleSkip = async () => {
    await updateAboutYou({ partnerPreferredName: "skip" })
    history.push(next)
  }

  const { register, handleSubmit, errors } = useForm()
  return (
    <FleLayout
      closeButton
      bottomContent={
        <FleContinueWrapper>
          <Skip onClick={handleSkip} onClickOnly enabled={!continueLoading} />
          <ContinueArrow onClick={handleSubmit(updatePartnerPreferredName)} enabled={!continueLoading} />
        </FleContinueWrapper>
      }
    >
      <Form onSubmit={handleSubmit(updatePartnerPreferredName)}>
        <AboutYouTopSection previous={previous}>
          <TopSection progressStep={3} leftOrBackArrow={<BackArrow onClick={() => goBack(previous)} />} />
        </AboutYouTopSection>
        <SwitchH2ToBodyLarge>{l`fle2.aboutyourpartner.preferredName.title`}</SwitchH2ToBodyLarge>
        <Spacer height={1} />
        <BodySmall color="black-80">{l`fle2.aboutyourpartner.preferredName.body`}</BodySmall>
        <Spacer height={2} />
        <CompleteFormInput
          name={"partnerPreferredName"}
          label={"Name"}
          value={partnerPreferredName}
          onChange={(e) => setPartnerPreferredName(e.target.value)}
          errors={errors}
          ref={register}
        />
      </Form>
    </FleLayout>
  )
}

export { AboutYourPartnerPreferredName }
